(function($){



/* from ambassadors-listing.js */
function ambassadors_ajax_filter_send(filter_values, product_values, country_values) {
    $.ajax({
        url: ajax.url,
        method: 'POST',
        data: {
            action: 'filter_ambassadors',
            filter_values: filter_values,
            product_values: product_values,
            country_values: country_values
        },
        success: function (response) {
            var donnees = JSON.parse(response);
            $('.ambassadors-listing-center-area').html(donnees.content);
        },
        error: function (xhr, textStatus) {

        },
        complete: function () {
            $('html').removeClass('loading-cursor');
        }
    });
}

function stickyCard() {

    $(".ambassador-follow-card.sticky-card").each(function () {
        var $window = $(window);
        var $sidebar = $(this);
        var $sidebarHeight = $sidebar.innerHeight();

        //Stop point
        var $specialGridTop = $sidebar.parents(".et_section_specialty").offset().top;
        var $specialGridHeight = $sidebar.parents(".et_section_specialty").outerHeight();
        var $footerOffsetTop = $specialGridTop + $specialGridHeight;

        //Top & width of sidebar
        var $sidebarOffset = $sidebar.offset();
        var $cardWidth = $sidebar.outerWidth();
        var $topspace = 30;
        if ($('.anchor-menu').length) {
            var $anchormenuheight = $('.anchor-menu').outerHeight() + $topspace;
            var $cardStickyTop = $('.anchor-menu').outerHeight() + $topspace;
        } else {
            var $anchormenuheight = 0 + $topspace;
            var $cardStickyTop = 0 + $topspace;
        }

        //When scrolling
        $window.scroll(function () {

            if ($window.scrollTop() > $sidebarOffset.top - $anchormenuheight) {
                $sidebar.addClass("fixed");
                $sidebar.css('top', $cardStickyTop + 'px');
                $sidebar.css('width', $cardWidth);

            } else {
                $sidebar.removeClass("fixed");
                $sidebar.css('width', 'auto');
            }
            if ($window.scrollTop() + $sidebarHeight + $anchormenuheight > $footerOffsetTop) {
                $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
            } else {
                $sidebar.css({"top": $cardStickyTop + 'px',});
            }
        });

        //When ready
        if ($window.scrollTop() > $sidebarOffset.top - $anchormenuheight) {
            $sidebar.addClass("fixed");
            $sidebar.css('top', $cardStickyTop + 'px');
            $sidebar.css('width', $cardWidth);

        } else {
            $sidebar.removeClass("fixed");
            $sidebar.css('width', 'auto');
        }
        if ($window.scrollTop() + $sidebarHeight + $anchormenuheight > $footerOffsetTop) {
            $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
        } else {
            $sidebar.css({"top": $cardStickyTop + 'px',});
        }
    });
}
/* from ambassadors-listing.js */



/* from ambassadors-listing.js */
if ($('.ambassador-select-tags-filter select').length) {
    $('.ambassador-select-tags-filter select').on('change', function () {
        var filter_values = $(this).val();
        var product_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-products-filter select').val();
        var country_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-country-filter select').val();
        $('html').addClass('loading-cursor');

        //console.log(product_values);
        //console.log(filter_values);
        //console.log(country_values);

        ambassadors_ajax_filter_send(filter_values, product_values, country_values);
    });
}

if ($('.ambassador-select-products-filter select').length) {
    $('.ambassador-select-products-filter select').on('change', function () {
        var product_values = $(this).val();
        var country_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-country-filter select').val();
        var filter_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-tags-filter select').val();
        $('html').addClass('loading-cursor');

        //console.log(product_values);
        //console.log(filter_values);
        //console.log(country_values);

        ambassadors_ajax_filter_send(filter_values, product_values, country_values);
    });
}

if ($('.ambassador-select-country-filter select').length) {
    $('.ambassador-select-country-filter select').on('change', function () {
        var country_values = $(this).val();
        var product_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-products-filter select').val();
        var filter_values = $(this).parents('.ambassadors-listing-form-area').find('.ambassador-select-tags-filter select').val();
        $('html').addClass('loading-cursor');

        //console.log(product_values);
        //console.log(filter_values);
        //console.log(country_values);

        ambassadors_ajax_filter_send(filter_values, product_values, country_values);
    });
}

if ($('.ambassador-follow-card.sticky-card').length) {
    $(window).on('load', function () {
        stickyCard();
    });
}

if ($('.ambassador-follow-card.sticky-card').length) {
    $(window).on('resize', function () {
        stickyCard();
    });
}
/* from ambassadors-listing.js */


if($('.ambassadors-grid-disc #countryFilter').length){
    $('.ambassadors-grid-disc #countryFilter').on('change', function () {
        var filterslug = $(this).val();
        $('.ambassador.local').hide();
        $('.ambassador.local[data-countries~="'+filterslug+'"]').show();
    });
}

if($('.ambassadors-grid-disc #genreFilter').length){
    $('.ambassadors-grid-disc #genreFilter').on('change', function () {
        var filterslug = $(this).val();
        $('.ambassador.local').hide();
        $('.ambassador.local[data-genres~="'+filterslug+'"]').show();
    });
}

})(jQuery);